import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { message } from "antd";
// import { toast } from "react-toastify"; // Switched to antd message

const StatusBadge = (props) => {
  const { item, api, activeLabel = "Published", inactiveLabel = "Draft" } = props;
  const [itemStatus, setItemStatus] = useState(true);

  useEffect(() => {
    const status = item.status;
    if (status === 1 || status === "1") {
      setItemStatus(true);
    } else if (status === 0 || status === "0") {
      setItemStatus(false);
    }
  }, [item.status]);

  const UpdateStatus = async (e, item) => {
    e.preventDefault();
    const id = item.id;
    const previousState = itemStatus;
    
    // Optimistic UI update
    setItemStatus(!itemStatus);
    
    try {
      const res = await api(id);
      if (res && res.Good === false) {
        setItemStatus(previousState);
        message.config({ zIndex: 1000000001 });
        message.error(res.data || "Failed to update status.");
      } else {
        message.config({ zIndex: 1000000001 });
        message.success("Status updated successfully!");
      }
    } catch (err) {
      setItemStatus(previousState);
      message.config({ zIndex: 1000000001 });
      message.error("An error occurred while updating status.");
    }
  };

  return (
    <>
      <Link to="#" onClick={(e) => UpdateStatus(e, item)}>
        {itemStatus === true ? (
          <span className="btn btn-success waves-effect waves-light btn-sm">
            {activeLabel}
          </span>
        ) : (
          <span className="btn btn-danger waves-effect waves-light btn-sm">
            {inactiveLabel}
          </span>
        )}
      </Link>
    </>
  );
};

export default StatusBadge;
